





































































































































































































import { Vue, Component } from "vue-property-decorator";
import { User } from "@/modules/auth/types";
import { namespace } from "vuex-class";

const Auth = namespace("auth");

@Component({})
export default class Dropdown extends Vue {
  @Auth.Action("logout") logout!: () => Promise<{}>;
  @Auth.Getter("getUser") user!: User;
  isDropdownOpen = false;

  constructor() {
    super();
  }

  isAdmin(allowDevelopers) {
    // 0 = Admin, 1 = Developer
    if (allowDevelopers) return this.user.role === 0 || this.user.role === 1 || this.user.role === 3;
    else return this.user.role === 0 || this.user.role === 3;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  logoutUser() {
    this.logout().then(() => {
      this.$router.replace({ name: "login" });
    });
  }
}
